/*
    Controller for the help screen
    This lists the relevant questions in sections
 */
angular.module('qkr').controller('helpController', ($scope, $uibModal, $rootScope, merchantService, helpService, $routeParams, $sce, $location, $anchorScroll, appConfig) => {
    $scope.isReportManager = appConfig.isReportManager;
    let questions = [];

    if ($scope.isReportManager) {
        questions = [
            {reference: 'reports', name: 'Reports', values: '7031,7032'}
        ];
    } else {
        questions = [
            {reference: 'product', name: 'Product', values: '1002,7001,7002,7003,7004,7005,7006,1201'},
            {reference: 'optionSets', name: 'Option Sets', values: '1003,7011,7012,7013'},
            {reference: 'menu', name: 'Menu', values: '1001,7021,7022,7023'},
            {reference: 'reports', name: 'Reports', values: '7031,7032'}
        ];
    }

    $scope.helpQuestions = []; // This is the actual list of questions with text pulled from help service
    $scope.currentQuestionId = null;

    $scope.resourceList = [];
    $scope.videoTutorials = [];
    
    $scope.accordionStatus = {
    		product: false,
    		optionSets: false,
            menu: false,
    		reports: false
    };

    // Call on page load
    $scope.init = function() {
        $scope.currentQuestionId = $routeParams.helpId;         // Use the route param by default

        if (helpService.helpLoaded) {
              setupQuestions();
         } else {
             helpService.loadHelp();
         }
        
         merchantService.loadMerchantInfo().then((merchantInfo) => {
        	 const category = getMerchantBusinessCategoryName(merchantInfo);
        	 
        	 helpService.getVideoTutorials(category).then((data) => {
        		 $scope.videoTutorials = data;
        		 if ($scope.videoTutorials.length == 0) {
        			 $scope.accordionStatus.productOpen = true;
        		 }
        	 });
             helpService.getResource(category).then((data) => {
                 $scope.resourceList = data;
                 if ($scope.resourceList.length == 0) {
                     $scope.accordionStatus.productOpen = true;
                 }
             });

         });
    };

    $rootScope.$on('HelpLoaded', (evt) => {
        $scope.helpQuestions = [];
        setupQuestions();
    });
    // Required to allow embedded html
    $scope.to_trusted = function(html_code) {
        return $sce.trustAsHtml(html_code);
    };
    
    $scope.openVideoTutorial = function(videoTutorial) {
        const modalInstance = $uibModal.open({
            template: require('../templates/video/videoTutorial.html'),
            controller: 'videoTutorialController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
            	videoTutorial() {
                    return videoTutorial;
                }
            }
        });

        modalInstance.result.then((selectedItem) => {
        }, () => {
        });
    };

    // Configure the list of questions
    function setupQuestions() {
        $scope.helpQuestions = [];

        for (let i = 0; i < questions.length; i++) {
            const group = questions[i];

            $scope.helpQuestions.push(group);

            group.questions = [];

            const helpids = group.values.split(',');

            for (let j = 0; j < helpids.length; j++) {
                addQuestion(group, helpids[j]);
            }
        }
        $location.hash('item' + $scope.currentQuestionId);

        $anchorScroll();
    }
    // Add a single question to the list
    function addQuestion(group, itemId) {
        const q = helpService.question(itemId);
        const a = helpService.answer(itemId);

        // Added isOpen attribute for the bootstrap uib-accordion
        group.questions.push({id: '' + itemId,
                                title: q,
                                content: a,
                                isOpen: itemId === $scope.currentQuestionId});
    }
    
    function getMerchantBusinessCategoryName(merchant) {
    	if (merchant.businessCategory) {
    		return merchant.businessCategory.name;
    	} else if (merchant.options) {
    		return merchant.options.category;
    	} else {
    		return null;
    	}
    }
});



// WEBPACK FOOTER //
// ./src/controllers/help.controller.js